module.exports = __webpack_public_path__ + "static/applestore-1d5af34fc4ac134efd73a66f804d5592.png";